import DescriptionIcon from '@mui/icons-material/Description';

export default DescriptionIcon;
